(function () {
  'use strict';

  angular.module('wsLrs.services').factory("CardGroup", ['Api', 'Resource', '$http', function (Api, Resource, $http) {
    var baseResource = new Resource("/card-groups", true),
      tenantBoundResource = new Resource("/card-groups", false);

    // Capture "overrides"
    var baseSave = _.bind(baseResource.save, baseResource);
    return _.extend(baseResource, {
      get: _.bind(tenantBoundResource.get, tenantBoundResource),
      list: _.bind(tenantBoundResource.list, tenantBoundResource),
      find: _.bind(tenantBoundResource.find, tenantBoundResource),
      getAll: function getAll(cfg) {
        cfg = cfg || {};
        cfg.maxLimit = cfg.maxLimit || 5000;
        return tenantBoundResource.getAll(cfg);
      },
      save: function save(cardGroup, cfg) {
        cfg = cfg || {
          params: {}
        };
        return baseSave(cardGroup, cfg).then(function () {
          cardGroup.cardIds = cardGroup.cardIds || [];
          cardGroup.previousCardIds = cardGroup.cardIds.slice();
          return cardGroup;
        });
      },
      removeReportFromGroup: function removeReportFromGroup(cardGroupId, cardId, cfg) {
        var url = "".concat(baseResource.__apiUrl()).concat(cardGroupId, "/remove-report/").concat(cardId);
        return $http.put(url, cfg).then(function (response) {
          return response;
        });
      }
    });
  }]).factory("CardGroupControl", ['$rootScope', '$uibModal', 'Alerts', 'Card', 'CardGroup', 'CardRegistry', 'CardDisplay', 'CardLoader', 'DefaultCardGroups', 'wsEventNames', '$location', function ($rootScope, $uibModal, Alerts, Card, CardGroup, CardRegistry, CardDisplay, CardLoader, DefaultCardGroups, wsEventNames, $location) {
    return {
      adoptCard: function adoptCard(cardId) {
        Card.adopt(cardId).then(function (result) {
          CardLoader.clearCache();
          DefaultCardGroups.clearCache();
          var card = CardRegistry.get(cardId);
          Alerts.raiseAlert({
            type: "success",
            text: (card ? "<b>" + card.title + "</b>" : "Card") + (result.foundExisting ? " is already copied to " : " was successfully copied to ") + "<a href='#/dashboard/your-cards'>Your Reports</a>."
          });
        });
      },
      deleteCard: function deleteCard(cardGroup, cardId) {
        // Remove it from display
        CardDisplay.removeCard(cardId);

        // Remove the card
        return Card.remove(cardId)

        // Then modify the group's card IDs and return the new card group length
        .then(function () {
          // Remove card from group's card IDs
          cardGroup.cardIds = _.reject(cardGroup.cardIds, function (id) {
            return id === cardId;
          });
          cardGroup.previousCardIds = cardGroup.cardIds.slice();
          return cardGroup.cardIds.length;
        });
      },
      exploreCard: function exploreCard(cardId) {
        var hasFilter = $location.search().filter;
        if (hasFilter) {
          $uibModal.open({
            templateUrl: "modules/app/settings/dashboards/modals/warn-filter-modal.html",
            controller: function controller($scope, $uibModalInstance, QuickFilters, Dashboards) {
              $scope.cancel = $uibModalInstance.dismiss;
              $scope.proceed = function () {
                $uibModalInstance.close(true); // Close modal
                $location.search('filter', null); // Clear the active quick filters
                QuickFilters.clearDashboardFilter(Dashboards.currentDashboard.id); // Clear the quick filters from cache
                $rootScope.$broadcast("explore-card", {
                  cardId: cardId
                }); // Call explore with no filters
              };
            },
            backdrop: 'static'
          });
        } else {
          $rootScope.$broadcast("explore-card", {
            cardId: cardId
          });
        }
      },
      advancedConfig: function advancedConfig(cardId) {
        $rootScope.$broadcast("explore-card", {
          cardId: cardId,
          advanced: true
        });
      },
      dashboards: function dashboards($scope, cardId) {
        $scope.cardId = cardId || $scope.cardId;
        return $uibModal.open({
          templateUrl: 'modules/app/settings/dashboards/modals/dashboard-access.html',
          controller: 'DashboardAccessModalCtrl',
          scope: $scope
        });
      },
      renameCard: function renameCard(cardId) {
        $rootScope.$broadcast(wsEventNames.card.rename + cardId);
      }
    };
  }]);
})();
